/* eslint-disable @typescript-eslint/no-unused-vars */

import { inject } from '@angular/core';
import {
  CanActivateFn,
  Router,
  ActivatedRouteSnapshot,
  RouterStateSnapshot,
} from '@angular/router';
import { AuthService } from './auth.service';

export const loginGuard: CanActivateFn = (
  route: ActivatedRouteSnapshot,
  state: RouterStateSnapshot,
) => {
  const authService = inject(AuthService);
  const router = inject(Router);

  const isLogout = route.queryParams['logout'] === 'true';

  if (isLogout) {
    authService.clearAllData();
    localStorage.clear();
    sessionStorage.clear();

    document.cookie.split(';').forEach(function (c) {
      document.cookie = c
        .replace(/^ +/, '')
        .replace(/=.*/, '=;expires=' + new Date().toUTCString() + ';path=/');
    });

    return true;
  }

  if (authService.isSessionActive()) {
    router.navigate(['/layout']);
    return false;
  }

  // `isSessionActive` dejó de limpiar al responder que no; la limpieza que antes ocurría de
  // rebote se conserva aquí explícita, para entrar al login sin restos de la sesión anterior.
  authService.clearAllData();

  return true;
};
